import { api } from '@/lib/api';
import type {
  StatementsResponse,
  StatementDetail,
  CreateStatementInput,
} from './types';

export async function fetchStatements(params: { pageNumber?: number; pageLength?: number } = {}): Promise<StatementsResponse> {
  return api.get<StatementsResponse>('/v4/acc-statements', params);
}

export async function fetchStatement(id: string): Promise<StatementDetail> {
  return api.get<StatementDetail>(`/v4/acc-statements/${id}`);
}

export async function createStatement(input: CreateStatementInput): Promise<unknown> {
  return api.post('/v4/acc-statements', input);
}

// --- Draft flow ---------------------------------------------------------------

export interface DraftReconciliation {
  id: string;
  status: string;
  created_at: string;
}

export interface PatchStatementInput {
  qb_account_id?: string | null;
  period_start?: string | null;
  period_end?: string | null;
  opening_balance?: string | null;
  closing_balance?: string | null;
  dms_document_id?: string | null;
  status?: string;
}

export async function createDraftStatement(
  initial: PatchStatementInput = {},
): Promise<DraftReconciliation> {
  return api.post<DraftReconciliation>('/v4/acc-statements/drafts', initial);
}

export async function patchStatement(id: string, input: PatchStatementInput): Promise<unknown> {
  return api.patch(`/v4/acc-statements/${id}`, input);
}

export async function startStatement(id: string): Promise<unknown> {
  return api.post(`/v4/acc-statements/${id}/start`, {});
}

export interface StatementLineInput {
  posted_date: string;
  description: string | null;
  amount: string;
  reference: string | null;
}

export async function putStatementLines(id: string, lines: StatementLineInput[]): Promise<unknown> {
  return api.put(`/v4/acc-statements/${id}/lines`, { lines });
}

export interface AiExtractResult {
  periodStart: string | null;
  periodEnd: string | null;
  openingBalance: string | null;
  closingBalance: string | null;
  lines: Array<{
    posted_date: string;
    description: string | null;
    amount: string;
    reference: string | null;
  }>;
}

export async function aiExtractStatement(id: string): Promise<AiExtractResult> {
  return api.post<AiExtractResult>(`/v4/acc-statements/${id}/ai-extract`, {});
}
